import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { MerchantPaymentBillingFilters } from './interfaces';

export const initFilters: MerchantPaymentBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.STATUS]: [],
  [FILTERS.MERCHANT_CODE]: [],
  [FILTERS.CUSTOMER_MSISDN]: []
};

export const activeFiltersCountMapper = (activeFilters: MerchantPaymentBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }
  if (activeFilters.merchant_code?.length > 0) {
    availableFiltersCount += 1;
  }
  if (activeFilters.status?.length > 0) {
    availableFiltersCount += 1;
  }
  if (activeFilters.customer_msisdn?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
